export enum UploadState {
    Added,
    Uploaded,
    Error,
}